import { Icon } from '@gitbook/spine-icons';
import { ActionableContainer, Button, Description, Group, Heading } from '@gitbook/spine-react';

import { DocumentationLink } from '../../../../../Components';
import { ContactSupportReasons, useContactSupport } from '../../../../../state/support';

export function CommunityPlan() {
    const contactSupport = useContactSupport();

    return (
        <ActionableContainer orientation="horizontal">
            <Group>
                <Group>
                    <Heading>Community plan</Heading>
                </Group>
                <Description>
                    Get GitBook free for open source or non-profit projects, with the option to earn
                    revenue from your docs.{' '}
                    <DocumentationLink path="account-management/plans/community">
                        Learn more
                    </DocumentationLink>
                    .
                </Description>
            </Group>
            <Button
                kind="secondary"
                label="Apply for Community"
                leadingIcon={Icon.Send}
                onPress={() => {
                    contactSupport({
                        reason: ContactSupportReasons.APPLY_FOR_COMMUNITY,
                        subject: `I'm interested in a Community plan`,
                    });
                }}
            />
        </ActionableContainer>
    );
}
